import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { escapeHtml } from '../../../../shared/html.helper';

@Component({
  selector: 'app-flag-manager-issue-detail',
  templateUrl: './flag-manager-issue-detail.component.html',
  styleUrls: ['./flag-manager-issue-detail.component.scss'],
})
export class FlagManagerIssueDetailComponent implements OnChanges, AfterViewInit {
  @Input() currentFlags: any[];
  @Input() selectedFlag: any;
  openGroupFlags: { [index: number]: boolean } = {};
  filteredFlags: any[] = [];

  @ViewChild('modalRef', { static: false }) modalRef!: ModalDirective;
  @ViewChild('flagLevelBody', { static: false }) flagLevelBody!: ElementRef<HTMLElement>;
  @ViewChildren('flagItem', { read: ElementRef }) flagItems!: QueryList<ElementRef<HTMLElement>>;

  get groupChanges() {
    if (this.filteredFlags.length === 0) return [];
    return this.filteredFlags.flatMap(flag => flag.changes || []);
  }

  ngAfterViewInit(): void {
    this.modalRef?.onShown?.subscribe(() => {
      this.scrollToTop();
    });
  }

  private scrollToTop(): void {
    const container = this.flagLevelBody?.nativeElement;
    if (!container) return;

    container.scrollTop = 0;
    if (typeof container.scrollTo === 'function') {
      container.scrollTo({ top: 0, behavior: 'auto' });
    }
  }

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentFlags'] || changes['selectedFlag']) {
      this.openGroupFlags = {};

      if (this.selectedFlag) {
        this.filteredFlags = [this.selectedFlag];
      } else {
        this.filteredFlags = this.currentFlags || [];
      }

      this.openGroupFlags[0] = true;
    }
  }

  openModal(): void {
    this.openGroupFlags = {};
    this.openGroupFlags[0] = true;

    this.modalRef.show();
  }

  closeModal(): void {
    this.modalRef.hide();
  }

  trackByIndex = (index: number) => index;

  toggleFlagAccordion(index: number): void {
    const wasOpen = !!this.openGroupFlags[index];
    this.openGroupFlags = {};
    if (!wasOpen) this.openGroupFlags[index] = true;

    requestAnimationFrame(() => {
      const container = this.flagLevelBody?.nativeElement;
      const el = this.flagItems?.toArray()[index]?.nativeElement;
      if (!container || !el) return;

      const cRect = container.getBoundingClientRect();
      const eRect = el.getBoundingClientRect();
      const top = container.scrollTop + (eRect.top - cRect.top);
      container.scrollTo({ top, behavior: 'smooth' });
    });
  }

  getSanitizedValue(value: string | null): SafeHtml | null {
    if (!value) return null;
    return this.sanitizer.bypassSecurityTrustHtml(escapeHtml(String(value)));
  }
}
